/* Panier (tiroir Impact) façon davidprotein.com, chargé par layout/theme.liquid :
   1. paliers en pastilles au-dessus d'une ligne à points : point relais offert (25 €), livraison à domicile offerte (50 €) ;
   2. lignes : origine du produit (« • Espagne »), cadeaux du pack mis en avant (« Cadeau offert : … », prix barré),
      quantité en pilule − / + ;
   3. « Abonne-toi à ton panier et économise » : passe chaque produit éligible sur son plan d'abonnement (dès 50 €) ;
   4. bouton de commande avec le total et le prix barré quand une remise s'applique.
   Le thème re-rend le tiroir à chaque changement : tout est réappliqué par un observateur.
   Styles : assets/sb-cart.css. */
(function () {
  var RELAIS = 2500, DOMICILE = 5000, SUB_MIN = 5000;

  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  // Origine affichée au-dessus du nom, comme le « • Or » de David (mêmes libellés que les cartes produit)
  var origin = function (h) {
    if (/box/.test(h)) return /iberique/.test(h) ? 'Espagne' : 'France & Espagne';
    if (/(chorizo|fuet|lomo|serrano|bellota|jamon)/.test(h)) return 'Espagne';
    if (/(saucisson|saucisse|auvergne)/.test(h)) return 'Massif central';
    return '';
  };

  var cart = null, plans = {}, busy = false;
  try { plans = JSON.parse(sessionStorage.getItem('sbcPlans') || '{}'); } catch (e) { plans = {}; }

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  // Plan d'abonnement de chaque produit (premier plan du produit), mis en cache pour la session
  function planFor(handle) {
    if (plans[handle] !== undefined) return Promise.resolve(plans[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var g = (p.selling_plan_groups || [])[0];
      var sp = g && g.selling_plans[0];
      var adj = sp && sp.price_adjustments && sp.price_adjustments[0];
      plans[handle] = sp ? { id: sp.id, pct: adj && adj.value_type === 'percentage' ? adj.value : 0 } : null;
      try { sessionStorage.setItem('sbcPlans', JSON.stringify(plans)); } catch (e) {}
      return plans[handle];
    }).catch(function () { return null; });
  }

  function milestones(drawer, total) {
    var bar = drawer.querySelector('free-shipping-bar');
    var host = bar ? bar.parentElement : drawer.querySelector('.cart-drawer__top');
    if (!host) return;
    var ms = drawer.querySelector('.sbc-ms');
    if (!ms) {
      ms = document.createElement('div');
      ms.className = 'sbc-ms';
      ms.innerHTML = '<div class="sbc-ms__cols"><span class="sbc-pill" data-at="r">Point relais offert</span><span class="sbc-pill" data-at="d">Domicile offert</span></div>' +
        '<div class="sbc-ms__track"><span class="sbc-ms__fill"></span><span class="sbc-dot" data-at="r" style="left:25%"></span><span class="sbc-dot" data-at="d" style="left:75%"></span></div>' +
        '<div class="sbc-ms__labels"><span>' + money(RELAIS).replace(',00', '') + '</span><span>' + money(DOMICILE).replace(',00', '') + '</span></div>' +
        '<p class="sbc-ms__msg"></p>';
      if (bar) bar.insertAdjacentElement('afterend', ms); else host.appendChild(ms);
    }
    // Points à 25 % et 75 % de la ligne (comme les pastilles de David), remplissage par tranche
    var pct = total >= DOMICILE ? 100 : total >= RELAIS ? 25 + (total - RELAIS) / (DOMICILE - RELAIS) * 50 : total / RELAIS * 25;
    ms.querySelector('.sbc-ms__fill').style.width = pct + '%';
    [].forEach.call(ms.querySelectorAll('[data-at="r"]'), function (e) { e.classList.toggle('is-on', total >= RELAIS); });
    [].forEach.call(ms.querySelectorAll('[data-at="d"]'), function (e) { e.classList.toggle('is-on', total >= DOMICILE); });
    var msg = total >= DOMICILE ? '🎉 <b>Livraison à domicile offerte</b> !'
      : total >= RELAIS ? '<b>Point relais offert</b> ✓ · plus que <b>' + money(DOMICILE - total) + '</b> pour la livraison à domicile offerte'
      : 'Plus que <b>' + money(RELAIS - total) + '</b> pour le point relais offert';
    var m = ms.querySelector('.sbc-ms__msg');
    if (m.innerHTML !== msg) m.innerHTML = msg;
  }

  function lines(drawer) {
    if (!cart) return;
    var byKey = {};
    cart.items.forEach(function (it) { byKey[it.key] = it; });
    [].forEach.call(drawer.querySelectorAll('line-item'), function (li) {
      var inp = li.querySelector('input[data-line-key]');
      var it = inp && byKey[inp.dataset.lineKey];
      if (!it) return;
      var info = li.querySelector('.line-item__info .v-stack') || li.querySelector('.line-item__info');
      var gift = it.properties && it.properties.Cadeau;
      if (info && !li.querySelector('.sbc-origin, .sbc-gift__tag')) {
        if (gift) {
          li.classList.add('sbc-gift');
          info.insertAdjacentHTML('afterbegin', '<span class="sbc-gift__tag">🎁 Cadeau offert</span>');
          var price = info.querySelector('price-list');
          if (price && it.final_line_price < it.original_line_price) {
            price.outerHTML = '<p class="sbc-gift__price"><b>' + money(it.final_line_price) + '</b><s>' + money(it.original_line_price) + '</s><em>Promotion appliquée</em></p>';
          }
        } else {
          var o = origin(it.handle);
          if (o) info.insertAdjacentHTML('afterbegin', '<p class="sbc-origin"><i></i>' + o + '</p>');
        }
      }
      // Quantité en pilule − / + (le thème met à jour le panier sur l'événement change du champ)
      [].forEach.call(li.querySelectorAll('input.quantity-input'), function (q) {
        if (q.closest('.sbc-qty')) return;
        var w = document.createElement('span');
        w.className = 'sbc-qty';
        q.parentNode.insertBefore(w, q);
        var minus = document.createElement('button');
        minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Diminuer la quantité');
        var plus = document.createElement('button');
        plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Augmenter la quantité');
        w.appendChild(minus); w.appendChild(q); w.appendChild(plus);
        var bump = function (d) {
          var v = Math.max(0, (parseInt(q.value, 10) || 0) + d);
          if (q.max && v > Number(q.max)) return;
          q.value = v;
          q.dispatchEvent(new Event('input', { bubbles: true }));
          q.dispatchEvent(new Event('change', { bubbles: true }));
        };
        minus.addEventListener('click', function () { bump(-1); });
        plus.addEventListener('click', function () { bump(1); });
      });
    });
  }

  function subscription(drawer) {
    if (!cart) return;
    var btn = drawer.querySelector('[name="checkout"]');
    if (!btn) return;
    var items = cart.items.filter(function (it) { return !(it.properties && it.properties.Cadeau); });
    if (!items.length) return;
    Promise.all(items.map(function (it) { return planFor(it.handle); })).then(function (ps) {
      var elig = [];
      items.forEach(function (it, i) { if (ps[i]) elig.push({ it: it, plan: ps[i] }); });
      var box = drawer.querySelector('.sbc-sub');
      if (!elig.length) { if (box) box.remove(); return; }
      var max = Math.max.apply(null, elig.map(function (e) { return e.plan.pct; }));
      var min = Math.min.apply(null, elig.map(function (e) { return e.plan.pct; }));
      var on = elig.every(function (e) { return e.it.selling_plan_allocation; });
      var ok = cart.total_price >= SUB_MIN || on;
      if (!box) {
        box = document.createElement('div');
        box.className = 'sbc-sub';
        var anchor = btn.closest('form') || btn;
        anchor.insertAdjacentElement('beforebegin', box);
      }
      var tag = max ? (min === max ? 'Économise ' + max + ' %' : "Jusqu'à -" + max + ' %') : '';
      var note = ok ? 'Livraison toutes les 4 semaines, annulable à tout moment' : 'Disponible dès ' + money(SUB_MIN) + ' de panier';
      var html = '<label><input type="checkbox"' + (on ? ' checked' : '') + (ok ? '' : ' disabled') + '><span>Abonne-toi à ton panier et économise<span class="sbc-sub__note">' + note + '</span></span></label>' + (tag ? '<span class="sbc-sub__tag">' + tag + '</span>' : '');
      if (box.dataset.html !== html) {
        box.dataset.html = html;
        box.innerHTML = html;
        box.querySelector('input').addEventListener('change', function (e) { toggleSub(e.target.checked, elig, box); });
      }
      box.classList.toggle('is-off', !ok);
    });
  }

  // Abonnement : chaque ligne éligible passe sur (ou quitte) son plan, une ligne à la fois, puis le thème recharge le tiroir.
  function toggleSub(want, elig, box) {
    if (busy) return;
    busy = true;
    box.classList.add('is-busy');
    var chain = Promise.resolve();
    elig.forEach(function (e) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: e.it.key, quantity: e.it.quantity, selling_plan: want ? e.plan.id : null })
        });
      });
    });
    chain.catch(function () {}).then(function () {
      busy = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  function checkoutTotal(drawer) {
    if (!cart) return;
    var btn = drawer.querySelector('button[name="checkout"], [name="checkout"]');
    if (!btn) return;
    var txt = money(cart.total_price) + (cart.original_total_price > cart.total_price ? '<s>' + money(cart.original_total_price) + '</s>' : '');
    var t = btn.querySelector('.sbc-total');
    if (!t) { t = document.createElement('span'); t.className = 'sbc-total'; (btn.querySelector('.text-with-icon') || btn).appendChild(t); }
    if (t.innerHTML !== txt) t.innerHTML = txt;
    // Le total est déjà dans le bouton : la ligne « Total » est masquée sur téléphone, la mention légale passe sous le bouton
    var form = btn.closest('form') || btn;
    var foot = form.parentElement;
    if (foot) [].forEach.call(foot.children, function (c) { if (c !== form && /^\s*Total/.test(c.textContent)) c.classList.add('sbc-totrow'); });
    if (!foot || !foot.querySelector('.sbc-legal')) form.insertAdjacentHTML('afterend', '<p class="sbc-legal">Taxes incluses. Remises et frais de livraison calculés au paiement.</p>');
  }

  // Barre du bloc d'achat : quand le panier seul atteint déjà 50 €, on le dit (sinon on croit la barre bloquée)
  var lastTotal = 0;
  function shipNotes() {
    [].forEach.call(document.querySelectorAll('sb-shipping-progress .sb-ship__msg'), function (m) {
      if (lastTotal >= DOMICILE && !m.querySelector('.sbc-own')) m.innerHTML = '<span class="sbc-own">🎉 Ton panier (' + money(lastTotal) + ') a déjà la <b>livraison à domicile offerte</b> !</span>';
    });
  }
  function watchShip() {
    [].forEach.call(document.querySelectorAll('sb-shipping-progress .sb-ship__msg'), function (m) {
      new MutationObserver(function () {
        if (!m.querySelector('.sbc-own')) getCart().then(function (c) { lastTotal = c.total_price; shipNotes(); }).catch(function () {});
      }).observe(m, { childList: true });
    });
    getCart().then(function (c) { lastTotal = c.total_price; shipNotes(); }).catch(function () {});
  }

  var queued = false;
  function enhance() {
    queued = false;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.querySelector('line-item, free-shipping-bar')) return;
    getCart().then(function (c) {
      cart = c;
      lastTotal = c.total_price;
      shipNotes();
      milestones(drawer, c.total_price);
      lines(drawer);
      subscription(drawer);
      checkoutTotal(drawer);
    }).catch(function () {});
  }
  function schedule() { if (!queued) { queued = true; setTimeout(enhance, 120); } }

  var watched = null, mo = null;
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer === watched) return;
    watched = drawer;
    if (mo) mo.disconnect();
    mo = new MutationObserver(function (list) {
      var own = list.every(function (m) {
        var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return el && el.closest('.sbc-ms, .sbc-sub, .sbc-qty, .sbc-total, .sbc-origin, .sbc-gift__price, .sbc-gift__tag');
      });
      if (!own) schedule();
    });
    mo.observe(drawer, { childList: true, subtree: true });
    schedule();
  }

  function start() {
    watchShip();
    watch();
    // Le constructeur de pack remplace tout le tiroir après l'ajout : on rebranche l'observateur sur le nouveau
    new MutationObserver(function () { if (!watched || !document.contains(watched)) watch(); }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
